// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"318":"capture","427":"connect","443":"about","497":"config"}[chunkId] + "-legacy." + {"318":"6927096b","427":"c4f3926d","443":"b4a7e670","497":"d766ca8f"}[chunkId] + ".js";
};